class DeezerService {
  constructor() {
    this.lastQuery = '';
  }

  getPlaylistDetails(playlistId) {
    return new Promise((resolve, reject) => {
      const callbackName = 'deezerCallback_' + Math.random().toString(36).substr(2, 9);
      
      window[callbackName] = (data) => {
        delete window[callbackName];
        document.head.removeChild(script);
        
        if (data.error) {
          reject(new Error(`Erreur Deezer: ${data.error.type} - ${data.error.message}`));
          return;
        }

        resolve(data);
      };

      const script = document.createElement('script');
      script.src = `https://api.deezer.com/playlist/${playlistId}?output=jsonp&callback=${callbackName}`;
      script.onerror = () => {
        delete window[callbackName];
        document.head.removeChild(script);
        reject(new Error('Erreur lors du chargement des données Deezer'));
      };
      document.head.appendChild(script);
    });
  }

  async searchPlaylists(query, limit = 25, index = 0) {
    try {
      if (query) {
        this.lastQuery = query;
      } else {
        query = this.lastQuery;
      }

      if (!query) {
        throw new Error('Aucun terme de recherche fourni');
      }

      // Recherche initiale
      const searchResults = await new Promise((resolve, reject) => {
        const callbackName = 'deezerCallback_' + Math.random().toString(36).substr(2, 9);
        
        window[callbackName] = (data) => {
          delete window[callbackName];
          document.head.removeChild(script);
          
          if (data.error) {
            reject(new Error(`Erreur Deezer: ${data.error.type} - ${data.error.message}`));
            return;
          }

          resolve(data);
        };

        const script = document.createElement('script');
        script.src = `https://api.deezer.com/search/playlist?q=${encodeURIComponent(query)}&limit=${limit}&index=${index}&output=jsonp&callback=${callbackName}`;
        script.onerror = () => {
          delete window[callbackName];
          document.head.removeChild(script);
          reject(new Error('Erreur lors du chargement des données Deezer'));
        };
        document.head.appendChild(script);
      });

      // Récupération des détails pour chaque playlist
      const detailedPlaylists = await Promise.all(
        searchResults.data.map(async (playlist) => {
          try {
            const details = await this.getPlaylistDetails(playlist.id);
            return {
              ...playlist,
              fans: details.fans,
              // Tentative de construction d'une description
              description: details.description || `Playlist ${playlist.title} avec ${details.nb_tracks} titres par ${details.creator.name}`
            };
          } catch (error) {
            console.warn(`Impossible de récupérer les détails pour la playlist ${playlist.id}:`, error);
            return playlist;
          }
        })
      );

      return {
        playlists: {
          items: detailedPlaylists.map(playlist => ({
            id: playlist.id,
            name: playlist.title,
            description: playlist.description || '',
            images: [{
              url: playlist.picture_xl || playlist.picture_big || playlist.picture
            }],
            owner: {
              display_name: playlist.user?.name || 'Utilisateur Deezer'
            },
            tracks: {
              total: playlist.nb_tracks
            },
            followers: {
              total: playlist.fans || 0
            },
            external_urls: {
              deezer: playlist.link
            },
            platform: 'deezer'
          })),
          total: searchResults.total || 0
        }
      };
    } catch (error) {
      console.error('Erreur lors de la recherche Deezer:', error);
      throw new Error('Impossible de récupérer les playlists Deezer : ' + error.message);
    }
  }
}

export default new DeezerService();